/* tslint:disable */
/* eslint-disable */
/**
 * openapi
 * bales cloud
 *
 * The version of the OpenAPI document: 1.0
 * Contact: test@example.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { GetTriggerEventTypes200Response } from '../models';
/**
 * TriggerEventTypeApi - axios parameter creator
 * @export
 */
export const TriggerEventTypeApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * トリガーイベントタイプ一覧取得API
         * @summary トリガーイベントタイプ一覧取得API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTriggerEventTypes: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/user/trigger_event_types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TriggerEventTypeApi - functional programming interface
 * @export
 */
export const TriggerEventTypeApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TriggerEventTypeApiAxiosParamCreator(configuration)
    return {
        /**
         * トリガーイベントタイプ一覧取得API
         * @summary トリガーイベントタイプ一覧取得API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTriggerEventTypes(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetTriggerEventTypes200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTriggerEventTypes(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * TriggerEventTypeApi - factory interface
 * @export
 */
export const TriggerEventTypeApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TriggerEventTypeApiFp(configuration)
    return {
        /**
         * トリガーイベントタイプ一覧取得API
         * @summary トリガーイベントタイプ一覧取得API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTriggerEventTypes(options?: any): AxiosPromise<GetTriggerEventTypes200Response> {
            return localVarFp.getTriggerEventTypes(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TriggerEventTypeApi - interface
 * @export
 * @interface TriggerEventTypeApi
 */
export interface TriggerEventTypeApiInterface {
    /**
     * トリガーイベントタイプ一覧取得API
     * @summary トリガーイベントタイプ一覧取得API
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TriggerEventTypeApiInterface
     */
    getTriggerEventTypes(options?: AxiosRequestConfig): AxiosPromise<GetTriggerEventTypes200Response>;

}

/**
 * TriggerEventTypeApi - object-oriented interface
 * @export
 * @class TriggerEventTypeApi
 * @extends {BaseAPI}
 */
export class TriggerEventTypeApi extends BaseAPI implements TriggerEventTypeApiInterface {
    /**
     * トリガーイベントタイプ一覧取得API
     * @summary トリガーイベントタイプ一覧取得API
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TriggerEventTypeApi
     */
    public getTriggerEventTypes(options?: AxiosRequestConfig) {
        return TriggerEventTypeApiFp(this.configuration).getTriggerEventTypes(options).then((request) => request(this.axios, this.basePath));
    }
}
